module.exports = __webpack_public_path__ + "img/innerMongolia_title.baf7f3cd.png";